/* unplugin-vue-components disabled */import { render } from "./MainFoot.vue?vue&type=template&id=e38e8d9c&scoped=true"
import script from "./MainFoot.vue?vue&type=script&lang=js"
export * from "./MainFoot.vue?vue&type=script&lang=js"

import "./MainFoot.vue?vue&type=style&index=0&id=e38e8d9c&scoped=true&lang=css"

import exportComponent from "D:\\WorkPlace\\官网\\html-bcepd-project-website-official-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e38e8d9c"]])

export default __exports__